import React from 'react';

/**
 * Form field wrapper used by every Hardware dialog. Provides:
 *   - icon-prefixed uppercase label (PrimeIcons class string, e.g. "pi-tag")
 *   - red asterisk when `required` is true
 *   - optional `hint` line beneath the input
 *   - inline `error` text (overrides hint when both are passed)
 *
 * Render the actual input as children — we don't wrap it in extra divs so
 * existing PrimeReact width/style props keep working.
 *
 * Style classes are defined in styles/pp-overrides.css.
 */
export default function FormField({
  icon,
  label,
  required = false,
  hint,
  error,
  htmlFor,
  children,
}) {
  return (
    <div className="pp-field">
      <label className="pp-field-label" htmlFor={htmlFor}>
        {icon && <i className={`pi ${icon}`} />}
        <span>{label}</span>
        {required && <span className="pp-field-required" aria-hidden="true">*</span>}
      </label>
      {children}
      {error ? (
        <p className="pp-field-error" role="alert">
          <i className="pi pi-exclamation-circle" />
          {error}
        </p>
      ) : hint ? (
        <p className="pp-field-hint">{hint}</p>
      ) : null}
    </div>
  );
}
